/**
 * cd-tidio-visibility — gate Tidio chat to the team-events landers.
 *
 * Tidio is loaded site-wide by its Shopify app embed (declared in
 * config/settings_data.json). The team's preference is to only show
 * the widget on the team-events lander and its post-form next-steps
 * page — those are the only surfaces where live chat is part of the
 * conversion flow. Everywhere else (PDPs, collections, cart, home,
 * misc pages) the widget should be invisible.
 *
 * Important caveat: this hides the widget AFTER Tidio loads — the
 * script itself still downloads on every page because we don't
 * control its injection. If true "don't load" becomes a requirement,
 * the alternative is to disable the app embed and manually inject
 * Tidio's loader on the team-events template only.
 *
 * Allowlist is exact-pathname match (with optional trailing slash).
 * Adding a new page like /pages/team-events-archive would NOT match
 * automatically — extend ALLOWED_PATHS instead. This avoids the
 * footgun of prefix-matching unrelated paths.
 *
 * Registers two readiness hooks so we don't miss the ready event
 * regardless of whether Tidio's script loads before or after this
 * one: `tidioChat-ready` document event for the pre-API case, and
 * `tidioChatApi.on('ready', ...)` for the post-API case.
 */
(function () {
  // The main lander lives at /pages/team-building (the production
  // page slug). The next-steps page kept its original team-events
  // slug — names are mismatched, but the slugs are what they are.
  var ALLOWED_PATHS = [
    '/pages/team-building',
    '/pages/team-events-next-steps',
    '/pages/team-event-next-steps'
  ];

  // Path that needs the launcher bumped up to clear the sticky CTA
  // bar. The next-steps page has no sticky bar, so default position
  // is fine there.
  var STICKY_CTA_PATH = '/pages/team-building';

  // Desktop and mobile need different bottom offsets because Tidio's
  // launcher size + default position differ between breakpoints.
  //   Desktop: small nudge (24px) — launcher sits close to the sticky
  //     CTA on the right edge with a slight overlap, which is the
  //     desired look.
  //   Mobile (≤980px): bigger lift (96px + safe-area) so the launcher
  //     clears the full-width sticky CTA bar instead of sitting on
  //     top of the "Get A Free Quote" button.
  // Tidio's adjustStyles takes one CSS rule per call; media queries
  // are wrapped in a second call per their docs.
  var BOTTOM_OFFSET_DESKTOP = '24px';
  var BOTTOM_OFFSET_MOBILE = 'calc(96px + env(safe-area-inset-bottom, 0px))';
  var MOBILE_BREAKPOINT = '980px';

  var positionApplied = false;

  function currentPath() {
    return window.location.pathname.replace(/\/+$/, '');
  }

  function isAllowedPath() {
    var path = currentPath();
    for (var i = 0; i < ALLOWED_PATHS.length; i++) {
      if (path === ALLOWED_PATHS[i]) return true;
    }
    return false;
  }

  function applyPosition() {
    if (positionApplied) return;
    var api = window.tidioChatApi;
    if (!api || typeof api.adjustStyles !== 'function') return;
    if (currentPath() !== STICKY_CTA_PATH) return;
    // Tidio's SDK uses the internal selector `#tidio` (not the DOM-
    // level `#tidio-chat`) and routes the rule through their own
    // positioning layer — works on desktop and mobile, including the
    // shadow DOM where regular CSS can't reach. Per docs, each rule
    // (or media query block) needs its own adjustStyles call.
    api.adjustStyles('#tidio { bottom: ' + BOTTOM_OFFSET_DESKTOP + ' !important; }');
    api.adjustStyles(
      '@media only screen and (max-width: ' + MOBILE_BREAKPOINT + ') {'
      + ' #tidio { bottom: ' + BOTTOM_OFFSET_MOBILE + ' !important; }'
      + ' }'
    );
    positionApplied = true;
  }

  function applyVisibility() {
    var api = window.tidioChatApi;
    if (!api) return;
    if (isAllowedPath()) {
      if (typeof api.show === 'function') api.show();
      applyPosition();
    } else {
      if (typeof api.hide === 'function') api.hide();
    }
  }

  document.addEventListener('tidioChat-ready', applyVisibility);

  if (window.tidioChatApi) {
    applyVisibility();
    if (typeof window.tidioChatApi.on === 'function') {
      window.tidioChatApi.on('ready', applyVisibility);
    }
  }
})();
